<!--<template>
  <div class="mip-container">
    <div class="container-fluid">
      <div class="grid">

        <div class="mip-card">
          <div class="mip-body">
            <img :src="require('../../assets/iahs/membership.png')" class="mip-view img-fluid" alt="" />
          </div>
          <div class="mip-footer d-flex align-items-center justify-content-between">
            <div class="title" v-html="'IAHS Membership'"></div>
            <div class="mip-btn">
              <router-link to="/" class="ih-btn">
                <div class="d-flex align-items-center">
                  <span v-html="'Explore'"></span>
                  <span class="icon-arrow-right ml-2 icon"></span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="mip-card">
          <div class="mip-body">
            <img :src="require('../../assets/iahs/instructor.png')" class="mip-view img-fluid" alt="" />
          </div>
          <div class="mip-footer d-flex align-items-center justify-content-between">
            <div class="title" v-html="'Iam Instructor '"></div>
            <div class="mip-btn">
              <router-link to="/" class="ih-btn">
                <div class="d-flex align-items-center">
                  <span v-html="'Explore'"></span>
                  <span class="icon-arrow-right ml-2 icon"></span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="mip-card">
          <div class="mip-body">
            <img :src="require('../../assets/iahs/programs.png')" class="mip-view img-fluid" alt="" />
          </div>
          <div class="mip-footer d-flex align-items-center justify-content-between">
            <div class="title" v-html="'Our Programs'"></div>
            <div class="mip-btn">
              <router-link to="/" class="ih-btn">
                <div class="d-flex align-items-center">
                  <span v-html="'Explore'"></span>
                  <span class="icon-arrow-right ml-2 icon"></span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>-->

<template>
  <div class="mip-container">
    <div class="container-fluid">
      <div class="grid">

        <div class="mip-card">
          <div class="mip-body">
            <img :src="row.image4" class="mip-view img-fluid" alt="" />
          </div>
          <div class="mip-footer d-flex align-items-center justify-content-between">
            <div class="title" v-html="row.title4"></div>
            <div class="mip-btn">
              <router-link v-if="row.redirect4" :to="row.redirect4" class="ih-btn">
                <div class="d-flex align-items-center">
                  <span v-html="row.button4"></span>
                  <span class="icon-arrow-right ml-2 icon"></span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="mip-card">
          <div class="mip-body">
            <img :src="row.image5" class="mip-view img-fluid" alt="" />
          </div>
          <div class="mip-footer d-flex align-items-center justify-content-between">
            <div class="title" v-html="row.title5"></div>
            <div class="mip-btn">
              <router-link v-if="row.redirect5" :to="row.redirect5" class="ih-btn">
                <div class="d-flex align-items-center">
                  <span v-html="row.button5"></span>
                  <span class="icon-arrow-right ml-2 icon"></span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="mip-card">
          <div class="mip-body">
            <img :src="row.image6" class="mip-view img-fluid" alt="" />
          </div>
          <div class="mip-footer d-flex align-items-center justify-content-between">
            <div class="title" v-html="row.title6"></div>
            <div class="mip-btn">
              <router-link v-if="row.redirect6" :to="row.redirect6" class="ih-btn">
                <div class="d-flex align-items-center">
                  <span v-html="row.button6"></span>
                  <span class="icon-arrow-right ml-2 icon"></span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
.mip-container {
  padding: 80px 0 50px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3,minmax(0,1fr));
  grid-gap: 12.25rem;
  gap: 2.2rem;
  width: 100%;
}
.mip-footer {
  padding: 23px 0
}
.title {
  color: #0D0D34;
  font-weight: bold;
  font-size: 33px;
  line-height: 1;
}
.ih-btn,
.ih-btn:hover *,
.ih-btn * {
  color: #000;
}
.ih-btn {
  font-size: 20px
}
.mip-view {
  width: 100%;
  height: 434px;
  object-fit: cover;
}


/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  
}

@media (max-width: 767.98px) {
  .grid {
    grid-template-columns: repeat(1,minmax(0,1fr));
  }
  .mip-view {
    height: auto;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
  
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .grid {
    grid-template-columns: repeat(2,minmax(0,1fr));
  }
  .mip-view {
    height: 274px;
  }
  .container-fluid {
    max-width: 720px;
    margin-right: auto;
    margin-left: auto;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .mip-view {
    height: 274px;
  }
  .title {
    font-size: 26px;
  }
  .ih-btn {
    font-size: 18px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .container-fluid {
    max-width: 1400px;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
